module.exports = __webpack_public_path__ + "img/logo.a0ff96e7.png";